import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import _ from 'lodash';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum , TE } from 'appconstants';
import { bindLogger } from 'helpers/BindLogger';
import { openConfirmation } from 'helpers/Confirmation';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import EditGroupOpenPersonTypes from './EditGroupOpenPersonTypes';
import { GroupOpenPersonColumns } from '../gridcolumns';

let setEditingStep;
const GroupOpenPersonComp = (props) => {
  const {
    data, saveOpenPerTypes, state, setState, editPermission
  } = props;
  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state?.personType) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingStep = (flg) => {
      setEditing(flg);
      setState({});
    };
    return (
      <EditGroupOpenPersonTypes
        state={state || row}
        setEditing={setEditing}
        setState={setState}
        defaultRow={row}
      />
    );
  };

  const saveOpenPersonTypes = () => {
    saveOpenPerTypes(state);
  };
  return (
    <ValidatorForm onSubmit={saveOpenPersonTypes}>
      <GridTable
        tag={`${TE.ID}lpoopenpersontypes${TE.TABLE}`}
        title="LPO OPEN Person Types"
        exportTitle={`LPO OPEN Person Types-${useGetPathProtocol()}-OPEN Setup`}
        columns={GroupOpenPersonColumns}
        user={GetUserFullName()}
        rows={data}
        editable
        editMode={editPermission}
        allowAddRow={editPermission}
        filterable
        sortable
        enableToolbar
        renderEditRow={RenderEditRow}
        rowEditable={() => true}
        toPdf={false}
      />
    </ValidatorForm>
  );
};

const GroupOpenPerson = compose(
  withAppContext,
  withState('state', 'setState', {
    isMandatory: false,
    isMultiple: false,
    esysStatus: 'ACTIVE'
  }),
  withHandlers({
    saveOpenPerTypes: props => postBody => {
      const {
        onSave,
        context,
        protocolId
      } = props;
        const confirmSave = () => {
          const {
            isMandatory, isMultiple, openProtPerRegTypeXrefs, personType, pptId, esysStatus
          } = postBody;
  
          const openProtPerRegTypeXref = openProtPerRegTypeXrefs.map(rt => (
            { personRegistrationType: rt.personRegistrationType, description: rt.description }));
  
          const payload = {
            isMandatory: !!isMandatory,
            isMultiple: !!isMultiple,
            openProtPerRegTypeXrefs: openProtPerRegTypeXref,
            personType,
            prtId: protocolId,
            pptId,
            esysStatus: esysStatus || 'ACTIVE'
          };
  
          bindLogger(onSave, context)(payload, protocolId).subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              openSnackbar({
                // Will remove the below hardcoded message once this added to db config table
                message: 'LPO OPEN Person Type Information saved successfully.', // SAVE_OPEN_PERSON_TYPES_SUCCESS,
                // GetFromCtxValue(context, 'PROTOCOL_REG_STEPS_SUCCESS')
                variant: 'success',
                name: 'lpo_person'
              });
              setEditingStep(false);
            }
          },  err => {
            context.logError(context, err.message, err.response.error);
            openConfirmation({
                title: 'Validation:',
                message: `${err.response.error}`,
                onAction: () => { },
                name: 'Group_Open_Person_Validation'
              });
          });
        };
      // Will remove the below hardcoded message once this added to db config table
      openConfirmation({
        message: 'Do you want to save the LPO OPEN Person Type Information?', // SAVE_OPEN_PERSON_TYPES_CONFIRM,
        onAction: confirmSave,
        name: 'lpo_open'
      });
    }
  })

)(GroupOpenPersonComp);

export default GroupOpenPerson;
